import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { IconAlert } from '../icons';
import { Button } from '../Button';
interface ErrorStateProps {
  onRetry: () => void;
}

/** Recoverable submission failure. */
export function ErrorState({
  onRetry
}: ErrorStateProps) {
  const {
    t
  } = useLanguage();
  return <div role="alert" className="border border-kred/60 bg-kred/10 p-5" data-id="element-275" data-mp="gb2kxacyi07a">
      <div className="flex items-start gap-3" data-id="element-276" data-mp="3oorpcjz8j6cz">
        <IconAlert className="mt-0.5 h-5 w-5 shrink-0 text-kred" data-id="element-277" data-mp="3ornna8b31v1f" />
        <p className="text-sm leading-relaxed text-white/85" data-id="element-278" data-mp="3jrje73ci82l8">{t('form.err.submit')}</p>
      </div>
      <div className="mt-4 flex flex-col gap-3 sm:flex-row" data-id="element-279" data-mp="2je8f5ysp9ps">
        <Button type="button" variant="solidLight" onClick={onRetry} className="sm:flex-1" data-id="element-280" data-mp="3toxlaccjff0v">
          {t('form.retry')}
        </Button>
      </div>
    </div>;
}